var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 12V4.66667L24.6667 12M8.00004 2.66667C6.52004 2.66667 5.33337 3.85333 5.33337 5.33333V26.6667C5.33337 27.3739 5.61433 28.0522 6.11442 28.5523C6.61452 29.0524 7.2928 29.3333 8.00004 29.3333H24C24.7073 29.3333 25.3856 29.0524 25.8857 28.5523C26.3858 28.0522 26.6667 27.3739 26.6667 26.6667V10.6667L18.6667 2.66667H8.00004Z",
    fill: "#00A43B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7904 22.306V23.056H19.6888L19.6576 22.4896L22.1107 18.6458H22.8646L22.0482 20.0443L20.6381 22.306H23.7904ZM23.0795 18.6458V24.3333H22.1381V18.6458H23.0795Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0717 22.2122H15.5912V21.4349H17.0717C17.3295 21.4349 17.5378 21.3932 17.6967 21.3099C17.8555 21.2266 17.9714 21.112 18.0443 20.9662C18.1198 20.8177 18.1576 20.6484 18.1576 20.4583C18.1576 20.2787 18.1198 20.1107 18.0443 19.9544C17.9714 19.7956 17.8555 19.668 17.6967 19.5716C17.5378 19.4753 17.3295 19.4271 17.0717 19.4271H15.892V24.3333H14.9115V18.6458H17.0717C17.5118 18.6458 17.8855 18.724 18.1927 18.8802C18.5026 19.0339 18.7383 19.2474 18.8998 19.5208C19.0612 19.7917 19.142 20.1016 19.142 20.4505C19.142 20.8177 19.0612 21.1328 18.8998 21.3958C18.7383 21.6589 18.5026 21.8607 18.1927 22.0013C17.8855 22.1419 17.5118 22.2122 17.0717 22.2122Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30994 18.6458H9.18494L10.8295 23.0326L12.4701 18.6458H13.3451L11.1732 24.3333H10.4779L8.30994 18.6458ZM7.9115 18.6458H8.74353L8.88806 22.4427V24.3333H7.9115V18.6458ZM12.9115 18.6458H13.7474V24.3333H12.767V22.4427L12.9115 18.6458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/MP4.76579cb4155902205a8e733b27a5c947.svg";
export { ForwardRef as ReactComponent };